module.exports = __webpack_public_path__ + "static/media/card_icon_4.2587a0d1.png";